module.exports = __webpack_public_path__ + "static/media/xlsx.46dca600.svg";